export enum ActionInstanceStatus {
    Active = "Active",
    Expired ="Expired",
    Closed = "Closed",
    Draft = "Draft"
}